import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import { homeModule } from './modules/home';
import { authModule } from './modules/auth';
import { datasetModule, datasetScaffolderModule } from './modules/dataset';
import { scmScaffolderModule } from './modules/scm';
import { ipLookupPlugin } from './modules/ipLookup';
import { platformToolsPlugin } from './modules/platformTools';
import { docThemeModule } from './modules/theme';

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    homeModule,
    authModule,
    datasetModule,
    datasetScaffolderModule,
    scmScaffolderModule,
    ipLookupPlugin,
    platformToolsPlugin,
    docThemeModule,
  ],
});
